export default __webpack_public_path__ + "static/media/close.8e3473f6.svg";